export function shouldShowDebugDataInUI() {
	return window.localStorage.getItem('showDebugDataInUI') === 'true';
}
export function shouldShowCTDebugAlert() {
	return window.localStorage.getItem('showCTDebugAlert') === 'true';
}
export function shouldShowButtonToSwitchCohort() {
	return window.localStorage.getItem('showButtonToSwitchCohort') === 'true';
}
